import { Formik } from 'formik'
import moment from 'moment'
import PropTypes from 'prop-types'
import { Component } from 'react'
import { FormattedMessage } from 'react-intl'

import { DateTimePicker, Text } from '@/components/Form'

import messages from './messages'

import './index.scss'

class ConnectorLogFilters extends Component<any, any> {
  static displayName = 'ConnectorLogFilters'

  static propTypes = {
    searchParams: PropTypes.object.isRequired,
    searchLogs: PropTypes.func.isRequired
  }

  isValidDateTime = (value: any) => {
    if (typeof value === 'string') {
      value = moment(value, moment.ISO_8601)
    }
    return value.isValid()
  }

  isValidEndDateOption = (value: any) => {
    let startDisplayTimestamp = this.props.searchParams.start
    if (startDisplayTimestamp === '') {
      startDisplayTimestamp = moment().toISOString()
    } else if (!this.isValidDateTime(startDisplayTimestamp)) {
      return false
    }
    value = typeof value === 'string' ? moment(value, moment.ISO_8601) : value
    return value.isAfter(moment(startDisplayTimestamp, moment.ISO_8601).subtract(1, 'day'), 'day')
  }

  onChangeDateTime = (id: any, value: any) => {
    const searchParams = {
      ...this.props.searchParams,
      offset: 0,
      [id]:
        typeof value === 'string'
          ? value // invalid date/time entered but let the user type anyway
          : value.toISOString() // moment object returned by react-datetime
    }
    this.props.searchLogs(searchParams)
  }

  onChangeCorrelationId = (element: any) => {
    const searchParams = {
      ...this.props.searchParams,
      offset: 0,
      correlationId: element && element.target ? element.target.value : element
    }
    this.props.searchLogs(searchParams)
  }

  render() {
    const { searchParams } = this.props

    return (
      // @ts-expect-error
      <Formik
        initialValues={{
          start: searchParams.start || '',
          end: searchParams.end || '',
          correlationId: searchParams.correlationId || ''
        }}
        enableReinitialize
      >
        <div className="flex flex-wrap">
          <DateTimePicker
            onChange={this.onChangeDateTime.bind(this, 'start')}
            label={<FormattedMessage {...messages.start} />}
            name="start"
            className="flex-auto"
            includeTime={true}
            showTime={true}
          />
          <DateTimePicker
            onChange={this.onChangeDateTime.bind(this, 'end')}
            isValid={this.isValidEndDateOption}
            label={<FormattedMessage {...messages.end} />}
            name="end"
            className="flex-auto"
            includeTime={true}
            showTime={true}
          />
          <Text
            name="correlationId"
            className="fill-space"
            label={<FormattedMessage {...messages.correlationId} />}
            onChange={this.onChangeCorrelationId.bind(this)}
          />
        </div>
      </Formik>
    )
  }
}

export default ConnectorLogFilters
